import { IDropdownOption } from '../../nvps-libraries/design/interfaces/design-library.interface';

export interface INavBarAccessibilityContent {
  openMenu: string;
  closeMenu: string;
  navBarLogoAltText: string;
}

export interface INavBarConfigContent {
  home?: string;
  messages?: string;
  myAccount?: string;
  checkIn?: string;
  resources?: string;
  [key: string]: string | undefined;
}

export interface ITranslateNavBarConfig {
  ariaLabel?: string;
  iconPosition?: 'before' | 'bothSides' | 'after';
  languages: IDropdownOption[];
  leftIconName?: string;
  selectedLangName?: string;
  size?: 'normal' | 'small';
}

/* eslint-disable no-unused-vars */
export enum NavBarType {
  SIDE_NAV = 'SIDE_NAV',
  TOP_NAV_CLOSED = 'TOP_NAV_CLOSED',
  TOP_NAV_OPENED = 'TOP_NAV_OPENED',
}
